<app-dialog
  [isVisible]="isDialogVisible"
  dialogHeader=" "
  [settings]="{
    showCustomFooter: true,
    closeOnEscape: true,
    isDraggable: ['draggable', 'all'].includes(dialogType),
    isResizable: true,
    isMaximizable: ['maximizable', 'all'].includes(dialogType),
    width: '95vw',
    maxWidth: dialogType === 'simple' ? '532.8px' : ''
  }"
  [emitOnHide]="true"
  (onHide)="handleDialogClose()"
>
  <div dialog-body>
    <div
      class="section-container flex flex-column gap-spacing-xl table-bg-hover-bg border-neutral-base-primary-bc radius-lg p-spacing-xl justify-content-center align-content-center"
    >
      <div class="flex justify-content-center">
        <img
          src="/assets/images/logo-Profilel.svg"
          alt="google"
        />
      </div>

      <div
        class="details-container flex flex-column justify-content-center align-items-center"
      >
        <span class="label-large-medium text-caption-color">Version {{ version() }}</span>

        <div class="border-neutral-base-seperator-color label-large-medium">
          <span class="text-link-color label-large-medium">
            <a
              href="https://www.goadroit.com/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              style="text-decoration: none; color: #1e63da"
            >
              Privacy policy
            </a>
          </span>
          |
          <span class="text-link-color label-large-medium">
            <a
              href="https://www.goadroit.com/terms-of-service"
              target="_blank"
              rel="noopener noreferrer"
              style="text-decoration: none; color: #1e63da"
            >
              Terms of service
            </a>
          </span>
        </div>
        <span class="fixed-text text-caption-color label-large-medium"
          >©{{ currentYear() }} Adroit Advanced Technologies Inc, a Beacon
          company. All rights reserved.</span
        >
      </div>
    </div>
  </div>
  <div dialog-footer>
    <div>
      <app-button
        label="Close"
        sizeClass="p-button-md"
        severity="secondary"
        (onClick)="handleDialogClose()"
        [outlinedButton]="true"
      ></app-button>
    </div></div
></app-dialog>
